import { useCallback } from 'react';
import { useDispatch, useSelector } from 'core/common/hooks';
import { copyWeb2AppLink, fetchNebulaAppLink } from '../store/actions';
import { getAppLink, getAppLinkLoadingStatus } from '../store/selectors';

export const useUserAppDownloadLink = () => {
  const dispatch = useDispatch();

  const appLink = useSelector(getAppLink);
  const appLinkLoadingStatus = useSelector(getAppLinkLoadingStatus);

  const fetchAppDownloadLink = useCallback(
    (host: string) => {
      dispatch(fetchNebulaAppLink(host));
    },
    [dispatch],
  );

  const copyAppDownloadLink = useCallback(
    (link: string) => dispatch(copyWeb2AppLink(link)),
    [dispatch],
  );

  return {
    fetchAppDownloadLink,
    copyAppDownloadLink,
    downloadAppLink: appLink,
    downloadAppLinkLoadingStatus: appLinkLoadingStatus,
  };
};
